import { beshrmakkiContentEn, blogArticlesEn } from './beshrmakki-content-en';

export const beshrmakkiContentAr = {
  brand: 'د. بشر مكي',
  nav: {
    home: { label: 'الرئيسية', href: '/' },
    services: { label: 'الخدمات', href: '/services' },
    about: { label: 'عن الدكتور', href: '/#about' },
    articles: { label: 'المقالات', href: '/blog' },
    reviews: { label: 'آراء المرضى', href: '/reviews' },
    contact: { label: 'اتصل بنا', href: '/contact' },
    cta: { label: 'احجز موعداً', href: '/contact' },
  },
  featured: {
    eyebrow: 'متخصص تفسير التحاليل',
    title: 'فهم نتائجك يبدأ من هنا',
    cta: 'تعرّف على خدماتنا',
  },
  hero: {
    headline: 'مُترجم رموز جسمك... لأن التحليل مش مجرد رقم على ورقة',
    intro:
      'متخصص في تفسير التحاليل الطبية، يعمل على تحويل البيانات المعقدة إلى معلومات واضحة تساعدك على اتخاذ القرارات الصحية بثقة.',
    subtext:
      'هدفنا ليس فقط تسليمك النتائج، بل تحويل البيانات المعقدة إلى رؤى واضحة تمنحك الطمأنينة والقدرة على اتخاذ القرارات الصحية الصحيحة.',
    badges: ['100% دقة تخصصية', 'ميزة الخصوصية والأمان'],
    cta: { label: 'احجز استشارة أو تواصل الآن', href: '/contact' },
  },
  about: {
    title: 'من هو د. بشر مكي؟',
    description:
      'الدكتور بشر مكي لا يرى المختبر كمجرد أنابيب اختبار، بل كبوابة لفهم الصحة الإنسانية. بصفته باحثاً وممارساً، يكرس وقته لفك شفرات النتائج الطبية.',
    pillars: [
      {
        title: 'مترجم معتمد',
        description: 'تحويل المصطلحات الطبية المعقدة إلى لغة مبسطة يفهمها المريض',
      },
      {
        title: 'دقة علمية',
        description: 'التركيز على الأسباب المتداخلة والدقيقة في مراجعة النتائج',
      },
      {
        title: 'تصحيح المفاهيم',
        description: 'إضاءة على الخرافات الطبية المنتشرة حول التحاليل المختلفة',
      },
    ],
    link: { label: 'تعرف المزيد عن د. بشر مكي', href: '/#about' },
  },
  values: {
    eyebrow: 'قيمنا',
    title: 'لماذا يثق المرضى في د. بشر مكي؟',
    subtitle: 'قيمنا هي مرجعنا، والآن تعرف عليها',
    items: [
      {
        title: 'الأمانة العلمية',
        description: 'نقل الحقيقة الطبية كاملة دون تهويل أو تهوين، مع الالتزام بالقسم الطبي.',
      },
      {
        title: 'الدقة المتناهية',
        description: 'فحص كل تفصيلة صغيرة في التقرير لضمان عدم غياب أي مؤشر صحي هام.',
      },
      {
        title: 'الموثوقية',
        description: 'نظام عمل صارم يضمن دقة النتائج وتكرارها تحت أي ظروف.',
      },
    ],
  },
  testimonials: {
    title: 'ماذا يقول المرضى عنا؟',
    items: [
      {
        quote:
          'كنت تائهاً بين المختبرات حتى شرح لي الدكتور بشر نتائج تحاليلى ببساطة مذهلة. الآن أعرف تماماً ما هي خطوتي القادمة.',
        author: 'أحمد م.',
        role: 'مريض سكري مزمن',
      },
      {
        quote:
          'الدقة والأمانة هي ما يميز هذا المكان، شعرت بالراحة النفسية بمجرد فهمي لكل رقم في التقرير الطبي الخاص بي.',
        author: 'سارة ك.',
        role: 'مراجعة دورية',
      },
    ],
  },
  articles: {
    eyebrow: 'الموضوعات الحالية',
    title: 'الموضوعات التي نتحدث عنها',
    subtitle: 'نشر الوعي الصحي يبدأ من المعلومة الصحيحة',
    viewAll: { label: 'شاهد جميع المقالات والفيديوهات', href: '/blog' },
    items: [
      {
        title: 'كيف تختار المختبر الصحيح؟',
        category: 'دليل المريض',
        excerpt: 'معايير الجودة التي يجب أن تبحث عنها قبل إجراء أي تحليل طبي هام.',
      },
      {
        title: 'خرافات حول نتائج التحاليل',
        category: 'ثقافة طبية',
        excerpt: 'لماذا لا تعني الزيادة الطفيفة دائماً وجود مرض؟ حقائق علمية صادمة.',
      },
      {
        title: 'قراءة الرموز المعقدة',
        category: 'تفسير النتائج',
        excerpt: 'شرح مبسط لأخطر الرموز الطبية التي تثير قلق المرضى في التقارير.',
      },
      {
        title: 'قبل التحليل.. ماذا تفعل؟',
        category: 'نصائح',
        excerpt: 'خطوات بسيطة تضمن لك نتائج دقيقة وتجنبك الحاجة لإعادة الفحص.',
      },
    ],
  },
  audience: {
    eyebrow: 'مناسب لـ',
    title: 'د. بشر مكي مناسب لـ',
    items: [
      'الباحثين عن رأي طبي دقيق وموثوق.',
      'العائلات التي ترغب في متابعة صحية دورية شاملة.',
      'مرضى الحالات المزمنة الذين يحتاجون تفسيراً لتطورات حالتهم.',
      'كل من يشعر بالقلق تجاه تحليل غير مفهوم.',
    ],
    cta: { label: 'تعرف على خدماتنا', href: '/services' },
  },
  mission: {
    title: 'رسالتنا',
    slogan: 'التحليل حياة',
    description:
      'نؤمن أن كل قطرة دم تحمل قصة، ومهمتنا هي قراءة هذه القصة بأمانة لنمنحك غداً أكثر صحة وإشراقاً.',
  },
  newsletter: {
    title: 'انضم إلى مجتمع الوعي الصحي',
    subtitle: 'احصل على أحدث النصائح الطبية وتفسيرات التحاليل في بريدك',
    instruction: 'أدخل بياناتك واضغط الاشتراك',
    namePlaceholder: 'الاسم',
    emailPlaceholder: 'البريد الإلكتروني',
    button: 'اشترك الآن',
    success: 'شكراً لاشتراكك! سنرسل لك أحدث النصائح قريباً.',
  },
  quote: {
    text: 'الرحلة بتبدأ بكلمة ... وأنا هنا عشان أقولك الكلمة الصح',
    attribution: 'د. بشر مكي — مترجم رموز جسمك',
  },
  footer: {
    aboutTitle: 'عن الدكتور',
    aboutDescription:
      'متخصص في تفسير التحاليل الطبية بدقة وأمانة علمية، يحوّل الأرقام المعقدة إلى رؤى واضحة تمنحك الطمأنينة.',
    legalTitle: 'معلومات قانونية',
    quickLinks: [
      { label: 'من هو د. بشر مكي؟', href: '/#about' },
      { label: 'الخدمات', href: '/services' },
      { label: 'المقالات', href: '/blog' },
      { label: 'احجز موعداً', href: '/contact' },
    ],
    copyright: '© 2026 د. بشر مكي - جميع الحقوق محفوظة، متخصص في التحاليل الطبية الدقيقة',
    links: [
      { label: 'إخلاء مسؤولية طبية', href: '/privacy' },
      { label: 'سياسة الخصوصية', href: '/privacy' },
      { label: 'شروط الاستخدام', href: '/terms' },
      { label: 'تواصل معنا', href: '/contact' },
    ],
    social: {
      facebook: 'https://www.facebook.com',
      instagram: 'https://www.instagram.com',
      twitter: 'https://www.twitter.com',
      youtube: 'https://www.youtube.com',
      whatsapp: 'https://wa.me/',
    },
  },
  servicesPage: {
    heroTitle: 'خدمات د. بشر مكي',
    heroDescription:
      'نقدّم خدمات متخصصة في تفسير التحاليل الطبية وتحويل الأرقام المعقدة إلى معلومات واضحة تساعدك على اتخاذ قراراتك الصحية بثقة.',
    pillarsLabel: 'خدماتنا',
    serviceCardCta: 'احجز استشارة',
    ctaHeading: 'هل لديك تقرير تحليل تحتاج تفسيره؟',
    ctaDescription: 'احجز استشارتك الآن مع د. بشر مكي واحصل على شرح واضح ومبسّط لنتائج تحاليلك.',
    ctaButtonText: 'احجز موعداً',
    methodologyLabel: 'منهجية العمل',
    methodologyHeading: 'كيف نعمل معك؟',
    phases: [
      {
        title: 'استلام التقرير',
        description: 'نراجع تقرير التحليل بعناية ونجمع كل المؤشرات والقيم المرجعية ذات الصلة بحالتك.',
      },
      {
        title: 'التفسير المبسّط',
        description: 'نحوّل المصطلحات الطبية والأرقام إلى لغة واضحة تفهمها أنت وعائلتك دون تهويل أو تقليل.',
      },
      {
        title: 'خطة المتابعة',
        description: 'نقدّم توصيات عملية للخطوة التالية: متابعة، فحوصات إضافية، أو استشارة طبية عند الحاجة.',
      },
    ],
    caseStudiesText: 'اقرأ مقالاتنا التوعوية',
    caseStudiesHref: '/blog',
    items: [
      {
        title: 'تفسير التحاليل الطبية',
        description: 'شرح شامل لنتائج تحاليل الدم والبول والفحوصات المخبرية بلغة مبسطة ودقيقة.',
      },
      {
        title: 'مراجعة التقارير الدورية',
        description: 'متابعة تطور مؤشراتك الصحية عبر الزمن وربط النتائج بسياق حالتك الطبية.',
      },
      {
        title: 'استشارة ما قبل التحليل',
        description: 'إرشادك بالتحضير الصحيح للفحوصات لضمان نتائج دقيقة من أول مرة.',
      },
      {
        title: 'توعية وتصحيح المفاهيم',
        description: 'نشر الوعي الصحي وتصحيح الخرافات الشائعة حول نتائج التحاليل المختلفة.',
      },
    ],
  },
  contactPage: {
    pageTitle: 'تواصل معنا',
    pageDescription: 'احجز استشارتك أو أرسل استفسارك حول نتائج تحاليلك. نحن هنا لمساعدتك على فهم تقريرك الطبي بوضوح.',
    emailLabel: 'البريد الإلكتروني',
    emailValue: 'info@beshrmakki.com',
    phoneLabel: 'الهاتف',
    phoneValue: '',
    locationLabel: 'الموقع',
    locationValue: 'استشارات طبية عبر الإنترنت والعيادة',
    formNameLabel: 'الاسم',
    formEmailLabel: 'البريد الإلكتروني',
    formSubjectLabel: 'الموضوع',
    formMessageLabel: 'رسالتك',
    formSubmitText: 'إرسال الرسالة',
    formSubmittingText: 'جاري الإرسال...',
    formSuccessText: 'تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.',
    formErrorText: 'فشل إرسال الرسالة.',
    profileBadge: 'د. بشر مكي',
    baseOperationsLabel: 'الاستشارات',
    baseCity: 'احجز موعدك الآن',
    baseDescription: 'سواء كانت زيارتك الأولى أو متابعة دورية، نضمن لك شرحاً واضحاً ودقيقاً لكل نتيجة في تقريرك.',
    officeLabel: 'واتساب',
    directionsText: 'تواصل مباشر',
    directionsUrl: 'https://wa.me/',
  },
  blogPage: {
    title: 'المقالات والوعي الصحي',
    subtitle: 'نشر الوعي الصحي يبدأ من المعلومة الصحيحة',
    emptyMessage: 'لا توجد مقالات حالياً.',
    readMore: 'قراءة المقال كاملًا',
    backToBlog: 'العودة إلى المقالات',
    notFound: 'المقال غير موجود.',
    author: 'د. بشر مكي',
  },
  privacyPage: {
    disclaimerTitle: 'إخلاء مسؤولية طبية',
    disclaimerBody: `المعلومات المقدّمة على هذا الموقع لأغراض توعوية وتفسيرية فقط، ولا تُغني عن الاستشارة الطبية المباشرة مع طبيب مختص.

لا يُعدّ أي محتوى على الموقع تشخيصاً طبياً أو وصفة علاجية. يجب على المريض مراجعة طبيبه المعالج قبل اتخاذ أي قرار علاجي بناءً على نتائج التحاليل.

د. بشر مكي غير مسؤول عن أي استخدام للمعلومات المنشورة دون استشارة طبية مناسبة.`,
    privacyTitle: 'سياسة الخصوصية',
    privacyBody: `نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية وفق أفضل الممارسات.

نجمع فقط البيانات التي تقدّمها طوعاً عبر نماذج التواصل أو الاشتراك في النشرة البريدية، ونستخدمها للرد على استفساراتك وتقديم الخدمات المطلوبة.

لا نشارك بياناتك مع أطراف ثالثة إلا عند الضرورة القانونية أو بموافقتك الصريحة.

يمكنك طلب حذف بياناتك أو تعديلها بالتواصل معنا عبر صفحة اتصل بنا.`,
  },
  termsPage: {
    title: 'شروط الاستخدام',
    body: `باستخدامك لهذا الموقع، فإنك توافق على الشروط التالية:

يُقدَّم المحتوى لأغراض معلوماتية وتفسيرية فقط ولا يُشكّل علاقة طبيب–مريض إلا بعد إتمام استشارة رسمية.

يُحظر نسخ أو إعادة نشر محتوى الموقع دون إذن كتابي مسبق.

نحتفظ بحق تعديل هذه الشروط في أي وقت، ويُعدّ استمرارك في استخدام الموقع موافقة على التعديلات.

لأي استفسار حول الشروط، يرجى التواصل معنا عبر صفحة اتصل بنا.`,
  },
  reviewsPage: {
    title: 'ماذا يقول المرضى عنا؟',
    subtitle: 'آراء حقيقية من مرضى استفادوا من خدمات تفسير التحاليل',
  },
} as const;

export type SiteContent = typeof beshrmakkiContentAr;
export const beshrmakkiContent = beshrmakkiContentAr;

export function getSiteContent(locale: 'ar' | 'en'): SiteContent {
  return locale === 'en' ? beshrmakkiContentEn : beshrmakkiContentAr;
}

export type BlogArticle = {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  created_at: string;
};

export const blogArticlesAr: BlogArticle[] = [
  {
    id: 1,
    title: 'كيف تختار المختبر الصحيح؟',
    category: 'دليل المريض',
    excerpt: 'معايير الجودة التي يجب أن تبحث عنها قبل إجراء أي تحليل طبي هام.',
    content: `اختيار المختبر المناسب خطوة أساسية لضمان دقة نتائجك. ابحث عن مختبر معتمد ومرخّص، وتحقق من شهادات الجودة مثل ISO.

اسأل عن طرق جمع العينات وتخزينها ونقلها، فأي خلل في هذه المرحلة قد يؤثر على النتيجة.

قارن بين المختبرات من حيث سرعة التسليم، وضوح التقرير، وتوفر استشارة لتفسير النتائج عند الحاجة.

لا تختار المختبر بناءً على السعر فقط؛ الدقة والموثوقية أهم من التوفير في الفحوصات الحساسة.`,
    created_at: '2026-01-15',
  },
  {
    id: 2,
    title: 'خرافات حول نتائج التحاليل',
    category: 'ثقافة طبية',
    excerpt: 'لماذا لا تعني الزيادة الطفيفة دائماً وجود مرض؟ حقائق علمية صادمة.',
    content: `كثير من المرضى يقلقون من أي رقم خارج المعدل الطبيعي، لكن الحقيقة أن الحدود المرجعية ليست حكماً نهائياً.

الزيادة الطفيفة قد تعكس ظروفاً مؤقتة مثل التوتر، أو نوع الطعام، أو توقيت أخذ العينة، وليس بالضرورة مرضاً.

التفسير الصحيح يتطلب النظر إلى الصورة الكاملة: الأعراض، التاريخ المرضي، والفحوصات السابقة.

لا تستعجل الحكم على صحتك من رقم واحد؛ استشر مختصاً يفسر النتيجة في سياق حالتك الكاملة.`,
    created_at: '2026-02-01',
  },
  {
    id: 3,
    title: 'قراءة الرموز المعقدة',
    category: 'تفسير النتائج',
    excerpt: 'شرح مبسط لأخطر الرموز الطبية التي تثير قلق المرضى في التقارير.',
    content: `تقارير التحاليل مليئة برموز واختصارات قد تبدو مخيفة: HbA1c، LDL، ALT، TSH وغيرها.

كل رمز يمثل مؤشراً محدداً لوظيفة في الجسم، وفهمه يبدأ بمعرفة ما يقيسه وليس فقط هل هو مرتفع أم منخفض.

المهم ليس حفظ الرموز، بل فهم ما تعنيه القيمة بالنسبة لحالتك الصحية الحالية.

دور المختص هو ترجمة هذه الرموز إلى لغة مفهومة تخبرك: هل تحتاج متابعة؟ تغيير نمط حياة؟ أم مراجعة طبيب؟`,
    created_at: '2026-02-20',
  },
  {
    id: 4,
    title: 'قبل التحليل.. ماذا تفعل؟',
    category: 'نصائح',
    excerpt: 'خطوات بسيطة تضمن لك نتائج دقيقة وتجنبك الحاجة لإعادة الفحص.',
    content: `التحضير الصحيح للتحليل يوفر عليك إعادة الفحص والقلق. اسأل المختبر عن الصيام المطلوب ومدته قبل تحاليل السكر والدهون.

تجنب المجهود البدني الشديد والتدخين قبل ساعات من أخذ العينة، واستمر على دوائك المعتاد ما لم يطلب الطبيب خلاف ذلك.

أخبر الفني عن أي أدوية أو مكملات تتناولها، فبعضها يؤثر على النتائج.

احتفظ بقائمة واضحة بتعليمات المختبر ولا تتردد في السؤال عند أي غموض؛ الدقة تبدأ قبل أخذ العينة.`,
    created_at: '2026-03-10',
  },
];

export const blogArticles = blogArticlesAr;

export function getBlogArticles(locale: 'ar' | 'en'): BlogArticle[] {
  return locale === 'en' ? blogArticlesEn : blogArticlesAr;
}
